import script from "./WaitingListSubscribe.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitingListSubscribe.vue?vue&type=script&setup=true&lang=js"

import "./WaitingListSubscribe.vue?vue&type=style&index=0&id=9990a79c&scoped=true&lang=css"

import exportComponent from "../../../publisher/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9990a79c"]])

export default __exports__